export default __webpack_public_path__ + "01043711691b2a73a726e4ce9b5133e8.png";